/* unplugin-vue-components disabled */import { render } from "./popupButtom.vue?vue&type=template&id=0a388632&scoped=true"
import script from "./popupButtom.vue?vue&type=script&lang=js"
export * from "./popupButtom.vue?vue&type=script&lang=js"

import "./popupButtom.vue?vue&type=style&index=0&id=0a388632&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a388632"]])

export default __exports__